import React from 'react';
import Box from '@amzn/meridian/box';
import Textarea from '@amzn/meridian/textarea';
import Text from '@amzn/meridian/text';
import { CAPAnsweredQuestionItem, Question } from './formData.types';
import { FormattedMessage, useIntl } from 'react-intl';

interface RenderGenericTextAreaFromDataProps {
  selected: CAPAnsweredQuestionItem | undefined;
  question: Question;
  styles: any;
  onChange: (args: CAPAnsweredQuestionItem) => void;
  height: number;
  width: string;
  disabled?: boolean;
}

const RenderGenericTextAreaFromData: React.FC<
  RenderGenericTextAreaFromDataProps
> = ({
  selected,
  question,
  styles,
  onChange,
  height,
  width,
  disabled = false,
}) => {
  const intl = useIntl();

  const handleChange = (value: string) => {
    onChange({
      checkedValue: value,
      numValue: undefined,
    });
  };

  return (
    <Box className={styles.genericTextBox}>
      <Text type='b300' className={styles.contactSummary}>
        <FormattedMessage
          id={question.QUESTION_TEXT.TRANSLATION_ID}
          defaultMessage={question.QUESTION_TEXT.DEFAULT_MESSAGE}
        />
      </Text>
      <Textarea
        value={(selected?.checkedValue as string) || ''}
        onChange={handleChange}
        error={false}
        rows={height}
        width={width}
        helperText=''
        disabled={disabled}
      />
    </Box>
  );
};

export default RenderGenericTextAreaFromData;
